<template>
  <div>
    <div class="output-group">
      <div class="output-title">
        <b>Dados do Sinistro</b>
      </div>

      <div>
        <span>Data / Hora Sinistro:</span>
        {{ sinistroData() }}
      </div>
      <div>
        <span>O que aconteceu:</span>
        <div class="output-textArea">
          {{ objDTO.Sinistro.SinistroDescricao }}
        </div>
      </div>
      <div>
        <span>Cobertura:</span>
        {{ coverageDesc() }}
      </div>
      <div>
        <span>Evento:</span>
        {{ eventDesc() }}
      </div>
      <slot name="otherFields"></slot>
    </div>
  </div>
</template>

<script>
import {
  getDescriptionFromArrayById,
  formatDisplayDateTime,
} from '../../../utils/helpers';

export default {
  props: {
    objDTO: Object,
    events: Array,
    coverages: Array,
  },
  methods: {
    sinistroData() {
      return formatDisplayDateTime(this.objDTO.Sinistro.SinistroData);
    },
    eventDesc() {
      return getDescriptionFromArrayById(
        this.events,
        this.objDTO.Sinistro.SinistroEventoId,
        'Id'
      );
    },
    coverageDesc() {
      return getDescriptionFromArrayById(
        this.coverages,
        this.objDTO.Apolice.ApoliceCoberturaId,
        'GisCoverageId'
      );
    },
  },
};
</script>

<style></style>
